module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-3.3b09ac19.png";